// Appels a l'API des courses (CalendrierControler cote serveur).

function entetes(): HeadersInit {
  return {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
  };
}

// Leve une erreur lisible (message du serveur si disponible) pour un statut
// inattendu.
export async function verifier(response: Response, statutsAttendus: number[]): Promise<Response> {
  if (statutsAttendus.includes(response.status)) return response;
  let message = 'statut ' + response.status;
  if (response.status === 404) message = 'course introuvable';
  if (response.status === 409) message = 'cette course a été chargée automatiquement : elle ne peut être ni modifiée ni supprimée';
  try {
    const erreur = await response.json();
    if (erreur?.message) message = erreur.message;
  } catch {
    // corps vide ou non JSON : on garde le message par defaut
  }
  throw new Error(message);
}

export function appelerApi(chemin: string, method: 'POST' | 'PUT' | 'DELETE', body?: unknown): Promise<Response> {
  return fetch(chemin, {
    method,
    headers: entetes(),
    body: body === undefined ? undefined : JSON.stringify(body),
  });
}

// Cle de la requete du tableau des courses (cf CourseGet.tsx), a invalider
// apres chaque modification.
export const CLE_TABLE_COURSES = ['table-event'];
